import DemoShell from "../components/layout/demo-shell";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { refreshToken, tokenExpiry, isTokenExpired, getTokenExpiry, withActiveToken } from '../lib/auth'
import Loading from '../components/ui/loading'
import LandingHero from "../components/layout/landing-hero";
import LandingFeatures from "../components/layout/landing-features";
import LandingWorkpegEmail from "../components/layout/landing-workpeg-email";
import LandingPreFooter from "../components/layout/landing-pre-footer";
import LandingFooter from "../components/ui/landing-footer";
import { getAPIURL, getCachedBusiness, setCachedBusiness } from "../lib/utils";

const Home = () => {
    const router = useRouter()
    const [tokenExpiryDate, setTokenExpiryDate] = useState(null);
    const cachedBusiness = getCachedBusiness();


    const fetchBusinessList = () => {
        
        return withActiveToken(() => {
            fetch(getAPIURL("businesses/"), {
                method: "GET",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
            }).then((res) => {
                if (res.ok) {
                    return res.json().then((json) => {
                        const activeBusiness = json[0];
                        router.push(`/${activeBusiness.uuid}/inbox`);
                        setCachedBusiness(activeBusiness);

                        return;
                    });
                }
                return res.json().then((json) => Promise.reject(json));
            });
        }, router);
    }

    useEffect(() => {
        const handleAuth = async () => {
            try {
                await refreshToken();
                setTokenExpiryDate(getTokenExpiry());

                if (!isTokenExpired(getTokenExpiry()) && cachedBusiness) {
                    router.push(`/${cachedBusiness}/inbox`);
                } else if (!isTokenExpired(getTokenExpiry()) && !cachedBusiness) {
                    await fetchBusinessList();
                }
            } catch (error) {
                setTokenExpiryDate(new Date(Date.now() - 60000)); // Set to 1 minute from now
            }
        };

        handleAuth();

    }, [router, cachedBusiness]);


    if (tokenExpiryDate === null) return <Loading />
    if (isTokenExpired(tokenExpiryDate)) {
        return (
            <DemoShell>
                <LandingHero />
                <LandingFeatures/>
                <LandingWorkpegEmail/>
                <LandingPreFooter/>
                <LandingFooter/>
            </DemoShell>
        );
    }
};

Home.isUnprotected = true;
export default Home;